import React, { ReactNode } from 'react';

export const AppLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex flex-col">
      {children}
    </div>
  );
};
